/** Logo — document knowledge definition. Pure data. */
export default {
  id: 'logo',
  name: 'Logo',
  description: 'A brand mark: the smallest, most reusable identity asset a business owns.',
  purpose: 'Brand Identity',
  recommendedSizes: [{ name: 'Square', width: 1024, height: 1024, unit: 'px' }],
  supportedOrientations: ['square'],
  supportsMultiplePages: false,
  supportsBleed: false,
  supportsImages: false,
  supportsIcons: true,
  supportsQR: false,
  supportsTables: false,
  supportsPricing: false,
  supportsCTA: false,
  supportsOffers: false,
  supportsTimeline: false,
  supportsGallery: false,
  typicalSections: ['Mark', 'Wordmark', 'Tagline'],
};
